import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { ProductsComponent } from './components/products/products.component';
import { DetailsProductComponent } from './components/details-product/details-product.component';
import { ListCatalogsComponent } from './components/list-catalogs/list-catalogs.component';
import { AskForQuotationComponent } from './components/ask-for-quotation/ask-for-quotation.component';
import { OrderStatusConfirmComponent } from './components/order-status-confirm/order-status-confirm.component';
import { ProductsAvailabilityDialogComponent } from './components/cart/products-availability-dialog/products-availability-dialog.component';
import { CatalogDetailsDialogComponent } from './components/catalog-details-dialog/catalog-details-dialog.component';

@NgModule({
  declarations: [
    ListCatalogsComponent,
    ProductsComponent,
    DetailsProductComponent,
    AskForQuotationComponent,
    OrderStatusConfirmComponent,
    ProductsAvailabilityDialogComponent,
    CatalogDetailsDialogComponent,
  ],
  imports: [CommonModule, SharedModule],
})
export class CatalogsModule {}
